import { z } from 'zod';
import { MAIL_LIMITS } from '../types/mail.js';
/**
 * Multipart fields validation. Each recipient field is a CSV of UUIDs on the
 * wire (`to`, `cc`, `bcc`); the route splits + trims + dedupes before this
 * schema sees them, so here we only check the resulting array shape.
 */
export const SendMailFieldsSchema = z.object({
    subject: z.string().trim().min(1).max(MAIL_LIMITS.subjectMaxLen),
    body: z.string().max(MAIL_LIMITS.bodyMaxLen),
    toUserIds: z.array(z.string().uuid()).max(MAIL_LIMITS.maxRecipients),
    ccUserIds: z.array(z.string().uuid()).max(MAIL_LIMITS.maxRecipients),
    bccUserIds: z.array(z.string().uuid()).max(MAIL_LIMITS.maxRecipients),
});
export const MailIdParamSchema = z.object({
    id: z.string().uuid(),
});
export const MailAttachmentIdParamSchema = z.object({
    id: z.string().uuid(),
});
//# sourceMappingURL=mail.schema.js.map